export enum DlpFileTypesMode {
  Off = 0,
  AllowList = 1,
  DenyList = 2
}

export enum DlpOnTimeout {
  Allow = 0,
  Block = 1,
  Quarantine = 2
}

export type IcapServerDto = {
  Name: string;
  Host: string;
  Port: number;
  ReqmodService: string;
  RespmodService: string;
};

export type DlpProfile = {
  Id: number;
  CustomerId: number | null;
  IsActive: boolean;
  Enabled: boolean;
  Server: IcapServerDto;
  MaxConnections: number | null;
  ConnectTimeoutMs: number;
  ReadTimeoutMs: number;
  WriteTimeoutMs: number;
  Attempts: number;
  BackoffMs: number;
  ResultTimeoutMs: number;
  WhenDownWaitMs: number;
  OnTimeout: DlpOnTimeout;
  ScanActions: number;
  FileTypesMode: DlpFileTypesMode;
  AllowedExt: string[];
  BlockedExt: string[];
  AllowedMime: string[];
  BlockedMime: string[];
  MaxFileSizeMb: number | null;
  UseHashCache: boolean;
  SkipOnIcapErrors: boolean;
  MaxMessageSizeKb: number | null;
  HashTtlMinutes: number | null;
  HashAlgo: string;
  IcapHeaders: Record<string, string>;
  Servers: IcapServerDto[];
};

export type GetDlpProfilesResponse = DlpProfile[];

export type GetDlpProfileResponse = DlpProfile;

export type SaveDlpProfileRequest = DlpProfile;

export type SaveDlpProfileResponse = DlpProfile;
